<template lang="pug">
  section.architecture
    h1(:class="titleAnimation") 端到端的云智能体系技术架构
    h2 以云计算+AI+区块链为底座，构建数字经济时代云操作系统，为行业提供端到端的智能解决方案，降低⾏业应⽤搭建⻔槛，提供增长服务
    viewer.viewer(:class="structureAnimation" v-show="structureIsShow" :images="[structure]")
      img(:src="structure" )
</template>

<script>
  // import structure from '@/assets/images/产品结构图2.png';
  const structure =
    'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E6%9E%B6%E6%9E%84%E5%9B%BE/%E4%BA%A7%E5%93%81%E7%BB%93%E6%9E%84%E5%9B%BE2.png';
  import Mixin from '../../index.js';
  
  export default {
    name: "architecture",
    mixins: [Mixin],
    props: {},
    data() {
      return {
        structure,
        isShow: false,
        structureIsShow: false,
      };
    },
    computed: {
      scrollTop: {
        get() {
          return this._scrollTop;
        },
        set(val) {
          const offsetTop = this.$el.offsetTop + 100;
          const innerHeight = window.innerHeight;
          if (val + innerHeight - offsetTop > 0) {
            this.setAnimate();
          }
          if (val + innerHeight - offsetTop - 200 > 0) {
            this.setStructureAnimation();
          }
        },
      },
      structureAnimation() {
        if (this.structureIsShow) {
          return 'animated slideInUp';
        }
      },
    },
    methods: {
      setStructureAnimation() {
        this.structureIsShow = true;
      },
    },
    created() {
    },
    mounted() {
    },
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .architecture {
    display flex
    flex-direction column
    align-items center
    justify-content flex-start
    padding 100px 0
    max-width 100vw
    .viewer {
      VStack(center)
      img {
        width calc(100% - 40px)
        max-width 1130px
        height auto
      }
      @media (max-width 1130px) {
        max-width 100%
      }
    }
    @media (max-width 1000px) {
      h2 {
        padding 20px
      }
    }
    
    @media (max-width screenWidth) {
      padding 50px 0
      h1, h2 {
        padding 0 20px
      }
      h1 {
        font-size 24px
        padding-bottom 0
        margin-bottom 20px
      }
      img {
        width calc(100vw - 40px)
        height auto
      }
    }
  }
</style>
